/*=============================================== SectionPage ===============================================*/

import { Section, Text } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const SectionPage = () => {
    const items: ItemType[] = [
        {
            content: (
                <Section gap="s">
                    <Text tag="h4">Section title</Text>
                    <Text>Section body</Text>
                </Section>
            ),
            code: '<Section gap="s">\n    <Text tag="h4">Section title</Text>\n    <Text>Section body</Text>\n</Section>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "gap",
            type: "string or number",
            possible: commonProps.spacers,
            default: "m",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default SectionPage
